import { StyleSheet } from 'react-native';
import { spacing, ticketColors, ticketFonts } from '../../shared/theme/public-api';

/**
 * Shell visual compartido para modales transversales (sin dependencia a Catálogo).
 * Patrones de filtros, listas y pickers: `modalExperience` en `components/shared/modals/`.
 */
export const modalShellShared = StyleSheet.create({
  modalCardShell: {
    borderColor: ticketColors.rule,
  },
  modalMaxCompact: {
    maxWidth: 560,
  },
  modalMaxComfortable: {
    maxWidth: 640,
  },
  modalMaxWide: {
    maxWidth: 1200,
  },
  modalHeaderRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
  },
  modalHeaderTitleBlock: {
    flex: 1,
    minWidth: 0,
    gap: 4,
  },
  modalHeaderKicker: {
    fontSize: 10,
    fontWeight: '700',
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    color: ticketColors.ink3,
    fontFamily: ticketFonts.mono ?? ticketFonts.sans,
  },
  modalHeaderTitle: {
    fontSize: 17,
    color: ticketColors.ink,
    fontWeight: '800',
    letterSpacing: -0.3,
    fontFamily: ticketFonts.sans,
  },
  sheetSubtitle: {
    fontSize: 13,
    color: ticketColors.ink2,
    fontWeight: '500',
    lineHeight: 18,
    fontFamily: ticketFonts.sans,
  },
  modalCloseButton: {
    width: 36,
    height: 36,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  modalCloseGlyph: {
    fontSize: 18,
    fontWeight: '400',
    color: ticketColors.ink2,
    lineHeight: 20,
    marginTop: -1,
    fontFamily: ticketFonts.sans,
  },
  heroBand: {
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    padding: spacing.md,
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: spacing.md,
  },
  heroBandText: {
    flex: 1,
    minWidth: 0,
    gap: spacing.xs,
  },
  heroKicker: {
    fontSize: 10,
    color: ticketColors.ink3,
    fontWeight: '700',
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    fontFamily: ticketFonts.mono ?? ticketFonts.sans,
  },
  heroBadge: {
    borderRadius: 999,
    borderWidth: 1,
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.gold,
    paddingHorizontal: spacing.sm,
    paddingVertical: 6,
    alignSelf: 'flex-start',
  },
  heroBadgeText: {
    fontSize: 11,
    color: ticketColors.goldInk,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
  },
  sectionDivider: {
    height: StyleSheet.hairlineWidth,
    backgroundColor: ticketColors.rule,
    opacity: 0.85,
    alignSelf: 'stretch',
  },
});
